export default "__VITE_ASSET__oRU_CZ2i__"